export default "__VITE_PUBLIC_ASSET__dd4f473c__"